import { activities } from "config";
import { findActivityBySlug, hasProperty } from "lib/util";

export type ActivityDataMap = {
  [Key in Travelguide.Activity]: Key extends "unterkunft"
    ? Travelguide.Outdooractive.AccomodationData
    : Key extends "touren"
    ? Travelguide.Outdooractive.TourData
    : Travelguide.Outdooractive.POIData;
};

export type ActivityDataResultMap = {
  [Key in Travelguide.Activity]: Key extends "unterkunft"
    ? Travelguide.Accomodation
    : Key extends "touren"
    ? Travelguide.Tour
    : Travelguide.POI;
};

export type ActivitySectionResultMap = {
  [Key in Travelguide.Activity]: Key extends "touren"
    ? Array<Travelguide.POISection | Travelguide.TourSection>
    : Array<Travelguide.POISection>;
};

export function getOOIType(slug: Travelguide.Activity) {
  return findActivityBySlug(slug)?.type;
}

function getCategoryIds(
  activityMap: Travelguide.ActivityMap
): Array<Travelguide.ID> {
  return ([] as Array<Travelguide.ID>).concat(
    hasProperty<"ids", Travelguide.ID>("ids")(activityMap)
      ? activityMap.ids
      : [],
    hasProperty<"categories", Array<Travelguide.ActivityMap>>("categories")(
      activityMap
    )
      ? activityMap.categories.flatMap(getCategoryIds)
      : []
  );
}

export function getCategoriesFromActivity(activity: Travelguide.Activity) {
  const root = findActivityBySlug(activity);
  return root ? getCategoryIds(root) : [];
}

function findActivityByCategoryId(
  id: string,
  parent: Travelguide.ActivityMap
): Travelguide.Activity | undefined {
  return hasProperty<"ids", Travelguide.ID>("ids")(parent) &&
    parent.ids.includes(id)
    ? parent.slug
    : hasProperty<"categories", Array<Travelguide.ActivityMap>>("categories")(
        parent
      )
    ? parent.categories.find((activity) =>
        findActivityByCategoryId(id, activity)
      )?.slug
    : undefined;
}

export function getActivityForCategoryId(id: string): Travelguide.ActivityRoot {
  const i = (activities as Array<Travelguide.ActivityRoot>).findIndex(
    (activity) => findActivityByCategoryId(id, activity) !== undefined
  );
  return (activities as Array<Travelguide.ActivityRoot>)[i];
}
